import PropTypes from 'prop-types';
import React from 'react';
import { StateMachineProvider, createStore } from 'little-state-machine';
import StepContainer from 'Components/StepContainer';
import Step1 from './Step1';
import Step2 from './Step2';
import Step3 from './Step3';
import Summary from './Summary';
import s from './CompanyGiftForm.module.scss';

const CompanyGiftForm = ({
    basename,
    formNamespace = 'companyGiftForm',
    gifts = [],
    countries = [],
    texts = {
        gdprText: '',
        gdprApprove: '',
        familymembersUnder18Notice: '',
        familymembersDescription: '',
    },
    campaignActivityNumber,
    paymentMethods = [],
}) => {
    return (
        <StateMachineProvider>
            <div className={s['CompanyGiftForm']} id="CompanyGiftForm">
                <StepContainer
                    formNamespace={formNamespace}
                    title="Välj belopp"
                    path="#"
                    basename={basename}
                >
                    <Step1
                        formNamespace={formNamespace}
                        gifts={gifts}
                        texts={texts}
                    />
                </StepContainer>
                <StepContainer
                    formNamespace={formNamespace}
                    title="Våra uppgifter"
                    path="#steg2"
                    basename={basename}
                >
                    <Step2
                        formNamespace={formNamespace}
                        countries={countries}
                        texts={texts}
                    />
                </StepContainer>
                <StepContainer
                    formNamespace={formNamespace}
                    title="Betalning"
                    path="#steg3"
                    basename={basename}
                >
                    <Step3
                        formNamespace={formNamespace}
                        paymentMethods={paymentMethods}
                    />
                </StepContainer>
                <Summary
                    formNamespace={formNamespace}
                    texts={texts}
                    campaignActivityNumber={campaignActivityNumber}
                />
            </div>
        </StateMachineProvider>
    );
};

/* eslint-disable react/prop-types */
const WithStore = (Component) => {
    const Store = (props) => {
        createStore(
            {
                [props.formNamespace]: {},
            },
            { name: props.formNamespace }
        );

        return <Component {...props} />;
    };
    return Store;
};
/* eslint-enable react/prop-types */

CompanyGiftForm.propTypes = {
    formNamespace: PropTypes.string,
    gifts: PropTypes.array,
    countries: PropTypes.array,
    texts: PropTypes.object,
    campaignActivityNumber: PropTypes.string,
    paymentMethods: PropTypes.array,
};

export default WithStore(CompanyGiftForm);
